import { Vector3 } from "three"

export const CAM_POSITION_INDEX = {
  start: {
    position: new Vector3(-5, 3, -0.5),
    target: new Vector3(0, 0, 0),
  },

  wide: {
    position: new Vector3(-0.8, 1.4, 1.7),
    target: new Vector3(0, 0, 0),
  },

  corner: {
    position: new Vector3(0.4, 0.6, -0.4),
    target: new Vector3(0, 0, 0),
  },

  C1: {
    position: new Vector3(0.6, 0.7, -0.6),
    target: new Vector3(0, 0, 0),
  },
  C2: {
    position: new Vector3(0.6, 0.7, 0.6),
    target: new Vector3(0, 0, 0),
  },
  C3: {
    position: new Vector3(-0.6, 0.7, 0.6),
    target: new Vector3(0, 0, 0),
  },
  C4: {
    position: new Vector3(-0.6, 0.7, -0.6),
    target: new Vector3(0, 0, 0),
  },
}

export const ROUTE_CAM_POSITIONS = {
  "/the-location": CAM_POSITION_INDEX.start,
  "/orbits": CAM_POSITION_INDEX.wide,
  "/residences": CAM_POSITION_INDEX.corner,
}
